import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { FlightBookingStep } from "@/feature/flight/checkout/components/shared/flight-booking-step-nav";
import { IFlightRevalidate } from "@/feature/flight/search/types/flight";

export interface IRevalidateFlightState {
  data?: IFlightRevalidate;
  searchId?: string | null;
}

interface FlightRevalidateState {
  revalidateFlight: IRevalidateFlightState;
  isRevalidating: boolean;
  flightTimer?: number;
  activeStep?: FlightBookingStep;
  highestReachedStep?: FlightBookingStep;
}

const initialState: FlightRevalidateState = {
  revalidateFlight: {
    data: undefined,
    searchId: null,
  },
  isRevalidating: false,
  flightTimer: undefined,
  activeStep: undefined,
  highestReachedStep: undefined,
};

const flightRevalidateSlice = createSlice({
  name: "flightRevalidate",
  initialState,
  reducers: {
    setRevalidateFlightData: (
      state,
      action: PayloadAction<IRevalidateFlightState>,
    ) => {
      state.revalidateFlight = action.payload;
    },
    resetRevalidateFlightData: (state) => {
      state.revalidateFlight = initialState.revalidateFlight;
    },
    setFlightTimer: (state, action: PayloadAction<number | undefined>) => {
      state.flightTimer = action.payload;
    },
    setActiveRevalidateStep: (
      state,
      action: PayloadAction<FlightBookingStep>,
    ) => {
      state.activeStep = action.payload;
    },
    setHighestReachedRevalidateStep: (
      state,
      action: PayloadAction<FlightBookingStep>,
    ) => {
      state.highestReachedStep = action.payload;
    },
    resetRevalidateSteps: (state) => {
      state.activeStep = undefined;
      state.highestReachedStep = undefined;
    },
    resetFlightRevalidateState: () => initialState,
  },
});

export const {
  setRevalidateFlightData,
  resetRevalidateFlightData,
  setFlightTimer,
  setActiveRevalidateStep,
  setHighestReachedRevalidateStep,
  resetRevalidateSteps,
  resetFlightRevalidateState,
} = flightRevalidateSlice.actions;

export default flightRevalidateSlice;
